<template>
  <table
    id="table-component"
    :class="{ condensed }"
  >
    <thead
      class="table-header"
      :class="{
        'all:hidden md:table-header-group': hideHeaderOnMobile,
        'sticky top-0 bg-white': stickyHeader,
      }"
    >
      <slot name="tableHeaders" />
    </thead>
    <slot name="tableBody">
      <tbody>
        <slot name="tableRows" />
      </tbody>
    </slot>
    <tfoot v-if="$slots.tableFooterRows">
      <slot name="tableFooterRows" />
    </tfoot>
  </table>
</template>

<script>
export default {
  name: 'Table',
  props: {
    hideHeaderOnMobile: {
      type: Boolean,
      default: true,
    },
    condensed: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
#table-component {
  width: 100%;

  th,
  td {
    padding: 1rem 0.5rem;
    font-size: $text-16;
    text-align: left;

    @media screen and (max-width: $md) {
      &:first-of-type {
        padding: 1rem {
          right: 0.5rem;
        }

        &:last-of-type {
          padding: 1rem;
        }
      }

      &:last-of-type {
        padding: 1rem {
          left: 0.5rem;
        }
      }
    }

    @media screen and (min-width: $xl) {
      padding: 1rem;
    }
  }

  &.condensed {
    th,
    td {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
  }

  th {
    color: $gray-700;
  }

  tr {
    border-bottom: 1px solid $gray-300;
  }

  p {
    margin-bottom: 0;
  }

  .cell-hide {
    display: none;

    @media screen and (min-width: $md) {
      display: table-cell;
    }
  }
}
</style>
